import React, { useEffect, useState } from "react";
import FlexibleSelect from "../form/select/FlexibleSelect";
import { taxonomyList } from "../../services/taxonomyService";
import { useQuery } from "@tanstack/react-query";
import DatePicker from "../form/DatePicker";

const TagFilter = ({
  isSelect = true,
  type = "event",
  selectedFilter,
  setSelectedFilter,
  setSelectFilterItem,
  setSelectedAllFilters,
  filterOptions = [],
}) => {
  const [filterList, setFilterList] = useState([]);

  // Fetch category data
  const { data: categoryData } = useQuery({
    queryKey: ["category"],
    queryFn: async () => {
      const res = await taxonomyList({
        limit: 10000,
        type: `${type}-category`,
      });
      return res?.docs;
    },
  });

  // Fetch tags data
  const { data: tagsData } = useQuery({
    queryKey: ["tags"],
    queryFn: async () => {
      const res = await taxonomyList({
        limit: 10000,
        type: `${type}-tag`,
      });
      return res?.docs;
    },
  });

  useEffect(() => {
    let mappedData = [];

    if (selectedFilter === "category" && categoryData) {
      mappedData = categoryData?.data?.map((item) => ({
        name: item?.title,
        value: item?._id,
      }));
    } else if (selectedFilter === "tags" && tagsData) {
      mappedData = tagsData?.data?.map((item) => ({
        name: item?.title,
        value: item?._id,
      }));
    } else if (selectedFilter === "status") {
      mappedData = [
        { name: "Active", value: "active" },
        { name: "Inactive", value: "inactive" },
      ];
    } else if (selectedFilter === "featured") {
      mappedData = [
        { name: "Yes", value: true },
        { name: "No", value: false },
      ];
    } else {
      mappedData = [];
    }

    setFilterList(mappedData);
  }, [selectedFilter, categoryData, tagsData]);

  // Push selected filter into array if not already present
  const handleFilterChange = (value) => {
    setSelectedFilter(value);

    setSelectedAllFilters((prev) => {
      if (!prev.includes(value)) {
        return [...prev, value];
      }
      return prev;
    });
  };

  return (
    <div className="flex space-x-4">
      <div className="relative w-60">
        <FlexibleSelect
          placeholder="Select Filter"
          onChange={handleFilterChange}
          selectedValue={selectedFilter}
          dropdownClass="!w-full"
          dropdownData={isSelect ? filterOptions : []}
        />
      </div>
      {selectedFilter === "dateRange" && (
        <div className="relative w-80">
          <DatePicker
            placeholder={"Select Date Range"}
            position="fixed"
            onChange={(e) =>
              setSelectFilterItem({
                type: "dateRange",
                value: { startDate: e?.startDate, endDate: e?.endDate },
              })
            }
            renge={true}
          />
        </div>
      )}

      {selectedFilter && selectedFilter !== "dateRange" && (
        <div className="relative w-60">
          <FlexibleSelect
            placeholder="Select Option"
            onChange={(value) => {
              setSelectFilterItem({
                type: selectedFilter,
                value: value,
              });
            }}
            dropdownClass="!w-full"
            dropdownData={filterList}
          />
        </div>
      )}
    </div>
  );
};

export default TagFilter;
